import { Footer } from '@/shared/ui/components';
import { MaintenanceBanner, useMaintenanceBanner } from '@/widgets/maintenance-banner';
import { LoginByBanner, LogoBanner, MarketingBanner } from '@/widgets/marketing-banner';
import { Sidebar } from '@/widgets/sidebar';
import { headphoneIcon } from '@/shared/ui/assets';
import { isWebViewCreateStudy, auth, CUSTOM_FRESHCHAT_ID_CLASSNAME } from '@/shared/lib';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';
import './style.scss';
import { useMain } from './useMain';

/**
 * Authenticated layout wrapping the routed page with the portal chrome. Renders the sidebar, the login-by banner, then the maintenance banner in place of the marketing and logo banners while it is shown and those banners otherwise, each when its flag is set, the outlet inside a body section whose classes reflect those banners, the footer, and the custom Freshchat launcher with its unread-count badge.
 *
 * @returns The authenticated layout element.
 */
const Main = () => {
  const { menu, openWidget, hasMarketingBanner, hasLogoBanner, hasLoginBanner } = useMain();
  const { isShowMaintenanceBanner, closeMaintenanceBanner } = useMaintenanceBanner();
  const hasMaintenanceBanner = isShowMaintenanceBanner && !isWebViewCreateStudy();

  return (
    <>
      <div
        className={classNames('app', {
          'app-webview': isWebViewCreateStudy(),
          'has-maintenance-banner': hasMaintenanceBanner,
        })}
      >
        <Sidebar menu={menu.current} />
        {auth.isAdminOrSales() && <LoginByBanner />}
        {hasMaintenanceBanner ? (
          <MaintenanceBanner onClose={closeMaintenanceBanner} />
        ) : (
          <>
            {hasMarketingBanner && <MarketingBanner />}
            {hasLogoBanner && <LogoBanner />}
          </>
        )}
        <section
          className={classNames('app-body', {
            'has-marketing-banner':
              auth.hasMarketingBanner() || auth.hasLogoBanner() || hasMaintenanceBanner,
            'has-login-banner': hasLoginBanner,
          })}
        >
          <Outlet />
        </section>
        <Footer />
      </div>
      <div id={CUSTOM_FRESHCHAT_ID_CLASSNAME.CONTAINER_ID} className="customer-freshchat-container">
        <button
          id={CUSTOM_FRESHCHAT_ID_CLASSNAME.BUTTON_ID}
          className="custom-freshchat-btn"
          onClick={openWidget}
        >
          <img
            id={CUSTOM_FRESHCHAT_ID_CLASSNAME.HOTLINE_ICON_ID}
            src={headphoneIcon}
            alt="Headphone icon"
          />
        </button>
        <div id={CUSTOM_FRESHCHAT_ID_CLASSNAME.NOTIFY_ID} className="unread-count" />
      </div>
    </>
  );
};

export default Main;
